var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.269,
    height: 11.535,
    viewBox: "0 0 18.269 11.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-svgrepo-com",
    transform: "translate(0 -37.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M0,37.748V49.283H18.269V37.748Zm17.5.772v.571L9.134,44.974.772,39.092V38.52ZM.772,48.512V40.036l8.14,5.726a.382.382,0,0,0,.222.071.377.377,0,0,0,.221-.071L17.5,40.035v8.476Z",
    fill: "#181818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMailIcon);
export default __webpack_public_path__ + "static/media/footer-mail-icon.14f726685a67d0b88ab45ecf820140b5.svg";
export { ForwardRef as ReactComponent };